
const EmpShortInfo = (props) => {
  const getInitials = (record = {}) => {
    const text = String(record.full_name || record.full_name_code || record.emp_code || 'U').trim();
    const parts = text.split(/\s+/).filter(Boolean);

    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    }

    return text.slice(0, 2).toUpperCase();
  };

  const hasProfileImage = props.record?.profile_pic_url && props.record.profile_pic_url !== "images/arnold-avatar.jpg" && props.record.profile_pic_url !== "/images/arnold-avatar.jpg";
  let name = '';

  if (props.record && props.record.emp_code === undefined) {
    name = <small className="employee-short-profile__single" title={ props.record.full_name_code }>{ props.record.full_name_code }</small>
  }
  else {
    name = (
      <div className="employee-short-profile__copy">
        <p title={ props.record && props.record.full_name }>{ props.record && props.record.full_name }</p>
        <p title={ props.record ? '(' + props.record.emp_code + ')' : '' }>{ props.record ? '(' + props.record.emp_code + ')' : '' }</p>
      </div>
    )
  }
  if (props.record && props.record.full_name && props.record.full_name.includes('-')) {
    name = <small className="employee-short-profile__single" title={ props.record.full_name }>{ props.record.full_name }</small>
  }
  return (
    <>
      { props.record ?
        <div className="employee-short-profile">
          { hasProfileImage ? (
            <img src={ props.record.profile_pic_url } alt="" className="employee-short-profile__avatar me-2" />
          ) : (
            <span className="employee-short-profile__avatar employee-short-profile__avatar--initials me-2">
              { getInitials(props.record) }
            </span>
          ) }
          { name }
        </div>
        : ''

      }
    </>
  )
}

export default EmpShortInfo
